import { RouteObject } from 'react-router';
import { PROTECTED_ROUTES } from '@/constants/route.constant';

export const settingsRoutes: RouteObject[] = [
  {
    path: PROTECTED_ROUTES.DASHBOARD.SETTINGS,
    lazy: {
      Component: async () =>
        (await import('./tokens/components/TokensPage')).default,
    },
  },
];
